import { render, staticRenderFns } from "./EnterTerminationCreateDocument.vue?vue&type=template&id=f456a006&scoped=true"
import script from "./EnterTerminationCreateDocument.vue?vue&type=script&lang=js"
export * from "./EnterTerminationCreateDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f456a006",
  null
  
)

export default component.exports